// extracted by mini-css-extract-plugin
module.exports = {"topic":"AllTopics_topic__g6XGf","highlight":"AllTopics_highlight__3gEO4","stats":"AllTopics_stats__1bqbf","disable":"AllTopics_disable__1JI3H"};